import React from 'react';
import { Link } from 'react-router-dom';
import HubPageLayout from '../components/HubPageLayout';
import FramedPanel from '../components/FramedPanel';
import { DASHBOARD_NAV } from '../navigation';

// Prevention Resources splash (9-22 mockups, framed 10-01), reached from the
// "Detection +" entries (sidebar group and desktop ribbon label; renamed 10-28,
// route unchanged): titled frame with the hero photo, then one link column per
// sub-group. Columns are derived from the nav so the splash and the sidebar
// can't drift apart.

// Same library-desk photo the mockup uses; already in the repo from the
// Feb-18 refactor. Large file - see the plan's dashboard backlog.
const HERO = '/images/Feb18ServerSideRefactorImages/wide21.jpeg';

const columnsFromNav = () => {
  const group = DASHBOARD_NAV.find((entry) => entry.id === 'prevention');
  // 10-05: the column headers are plain titles. They name sidebar groups
  // (MoSAIC PSYOPS, Detection tools, Av Library, Pulse), which are drop-downs
  // in the nav rather than pages, so linking them went somewhere arbitrary.
  return (group?.items || []).map((sub) => ({
    label: sub.label,
    items: sub.items,
  }));
};

const PreventionResourcesPage = () => {
  const columns = columnsFromNav();
  return (
    <HubPageLayout>
      {/* Same framed hero as Fraud Alerts: title on the frame, photo inside. */}
      <FramedPanel title="Tools designed to make you ScammerAware.">
        <div className="px-6 pt-10 pb-6">
          <img
            src={HERO}
            alt="A woman working at a laptop in front of bookshelves"
            className="w-full max-h-[340px] object-cover block"
          />
        </div>
      </FramedPanel>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 mt-8">
        {columns.map((col) => (
          <div key={col.label}>
            <h2 className="text-xl font-bold text-black">{col.label}</h2>
            <ul className="mt-1">
              {col.items.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="block text-xl text-black hover:text-blue-600 hover:underline"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </HubPageLayout>
  );
};

export default PreventionResourcesPage;
